import { CompanyAcronymsEnum } from '@orgbrain/roles';
import {
  BillingPackageID,
  OrganizationSubscriptionDeclaration,
  ReinvoicingRadioButtonType,
} from './lib-admin';

export enum SUPPORTED_CURRENCY {
  NOK = 'NOK',
}

const getRepeatableData = () => ({
  signaturePrices: [
    {
      price: 20,
      currency: SUPPORTED_CURRENCY.NOK,
      isAnnualPrice: true,
    },
    {
      price: 20,
      currency: SUPPORTED_CURRENCY.NOK,
      isAnnualPrice: false,
    },
  ],
  storagePrices: [
    {
      price: 240,
      currency: SUPPORTED_CURRENCY.NOK,
      isAnnualPrice: true,
    },
    {
      price: 20,
      currency: SUPPORTED_CURRENCY.NOK,
      isAnnualPrice: false,
    },
  ],
});

const getUserPrices = (monthUserPrice = null, annualUserPrice = null) => {
  monthUserPrice = monthUserPrice || 249;
  annualUserPrice = annualUserPrice || 199;
  return {
    userPrices: [
      {
        price: annualUserPrice * 12,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: true,
      },
      {
        price: monthUserPrice,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: false,
      },
    ],
    subgroupUserPrices: [
      {
        price: 99 * 12,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: true,
      },
      {
        price: 198,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: false,
      },
    ],
  };
};

export enum PACKAGE_CATEGORY {
  TOP_TIER = 'TOP_TIER',
  TIER2 = 'TIER2',
  NIF = 'NIF',
  ADMIN_LAYER = 'ADMIN_LAYER',
  MODULE = 'MODULE',
  SERVICES = 'SERVICES',
}

export const packageDump = [
  {
    reinvoicingRadioButton: ReinvoicingRadioButtonType.ASK,
    packageId: BillingPackageID.TEST,
    isPackageHiddon: true,
    onlyClientAdminCanOrder: true,
    packageName: 'Test',
    orderIndex: 0,
    packagePrices: [],
    userPrices: [],
    signaturePrices: [],
    storagePrices: [],
    packageMaxValidityDays: 14,
    isMainSubscription: true,
    includedStorage: 10737418240,
    includedUsers: -1,
    hidePriceSection: true,
    hideAnnualSelector: true,
    texts1en: [],
    features1en: [],
    texts1nb: [],
    features1nb: [],
    icon: 'Orgbrain-start.svg',
    category: PACKAGE_CATEGORY.ADMIN_LAYER,
    triggersDropOfAuxiliarySubscriptions: true,
  },
  {
    reinvoicingRadioButton: ReinvoicingRadioButtonType.ASK,
    packageId: BillingPackageID.FREEMIUM,
    isPackageHiddon: false,
    onlyClientAdminCanOrder: false,
    packageBuilder: true,
    packageName: 'Freemium',
    orderIndex: 0,
    packagePrices: [],
    userPrices: [],
    signaturePrices: [],
    storagePrices: [],
    isMainSubscription: true,
    includedStorage: 10737418240,
    includedUsers: -1,
    hidePriceSection: true,
    hideAnnualSelector: true,
    nifTexts1en: [
      "Orgbrain Start is a free subscription that gives you access to Orgbrain. Here you get a selection of functionality, and you can easily upgrade to one of our main subscriptions when you're ready.",
    ],
    nifTexts1nb: [
      'Orgbrain Start er et gratis abonnement som sikrer deg tilgang til Orgbrain. Her får du et utvalg av funksjonalitet, og du kan enkelt oppgradere til et av våre hovedabonnement når dere er klar.',
    ],
    texts1en: [
      'Build your own subscription. Start with a limited-feature version and build from there. You can choose from these modules.',
    ],
    features1en: ['Academy', 'Surveys', 'Shareholder Pro' /*'Annual Meeting Pro'*/],
    nifFeatures1en: [],
    nifFeatures1nb: [],
    texts1nb: [
      'Bygg ditt eget abonnement. Start med en versjon med begrensede funksjoner og bygg videre derfra. Du kan velge mellom disse modulene.',
    ],
    features1nb: ['Academy', 'Undersøkelser', 'Aksjonær Pro' /*'Årsmøte Pro'`*/],
    icon: 'Orgbrain-start.svg',
    category: PACKAGE_CATEGORY.TOP_TIER,
    triggersDropOfAuxiliarySubscriptions: false,
  },
  {
    reinvoicingRadioButton: ReinvoicingRadioButtonType.ASK,
    packageId: BillingPackageID.TEST2024,
    onlyClientAdminCanOrder: true,
    onlyClientAdminCanSeeIt: true,
    packageName: 'Test',
    orderIndex: 0,
    packagePrices: [],
    userPrices: [],
    signaturePrices: [],
    storagePrices: [],
    packageMaxValidityDays: 14,
    isMainSubscription: true,
    includedStorage: 10737418240,
    includedUsers: -1,
    hidePriceSection: true,
    hideAnnualSelector: true,
    mergeIntoTopPack: true,
    texts1en: [],
    features1en: [],
    texts1nb: [],
    features1nb: [],
    icon: 'Orgbrain-pro.svg',
    category: PACKAGE_CATEGORY.ADMIN_LAYER,
    triggersDropOfAuxiliarySubscriptions: true,
  },
  {
    reinvoicingRadioButton: ReinvoicingRadioButtonType.ASK,
    packageId: BillingPackageID.DEPENDENT,
    isPackageHiddon: true,
    packageName: 'DEPENDENT',
    orderIndex: 0,
    packagePrices: [],
    userPrices: [],
    signaturePrices: [],
    storagePrices: [],
    isMainSubscription: true,
    includedStorage: 10737418240,
    includedUsers: -1,
    hidePriceSection: true,
    hideAnnualSelector: true,
    texts1en: [],
    features1en: [],
    texts1nb: [],
    features1nb: [],
    icon: 'Orgbrain-pro.svg',
    category: PACKAGE_CATEGORY.ADMIN_LAYER,
    triggersDropOfAuxiliarySubscriptions: true,
  },
  {
    excludeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.ASK,
    packageId: BillingPackageID.BOARDSCHOOL,
    packageName: 'Board school',
    orderIndex: 1,
    packagePrices: [],
    userPrices: [],
    signaturePrices: [],
    storagePrices: [],
    packageMaxValidityDays: -1,
    isMainSubscription: false,
    includedStorage: 10737418240,
    includedUsers: -1,
    hidePriceSection: true,
    hideAnnualSelector: true,
    isPackageHiddon: true,
    texts1en: [],
    features1en: [],
    texts1nb: [],
    features1nb: [],
    icon: 'Orgbrain-pro.svg',
    category: PACKAGE_CATEGORY.MODULE,
    dropThisOnOrderMainPackage: true, // This package is dropped when a main package is ordered
  },
  {
    excludeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.ACADEMY_2025,
    packageName: 'Academy',
    orderIndex: 7,
    packagePrices: [],
    userPrices: [
      {
        price: 2628,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: true,
      },
    ],
    ...getRepeatableData(),
    packageMaxValidityDays: -1,
    isMainSubscription: false,
    includedStorage: 10737418240,
    includedUsers: -1,
    hideAnnualSelector: true,
    texts1en: ['Online certification course with exam and diploma.'],
    features1en: ['Board School', 'Supervisors', 'Webinars'],
    texts1nb: ['Nettbasert serifiseringskurs med eksamen og diplom.'],
    features1nb: ['Styreskolen', 'Veiledere', 'Webinarer'],
    icon: 'Academy.svg',
    category: PACKAGE_CATEGORY.MODULE,
    dropThisOnOrderMainPackage: true, // This package is dropped when a main package is ordered
  },
  {
    excludeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.BOARD_EVALUATION,
    packageName: 'Board evaluations',
    orderIndex: 7,
    packagePrices: [
      {
        price: 3900,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: true,
      },
    ],
    userPrices: [],
    ...getRepeatableData(),
    packageMaxValidityDays: -1,
    isMainSubscription: false,
    includedStorage: 10737418240,
    includedUsers: -1,
    hideAnnualSelector: true,
    texts1en: [
      'For boards that want a simple and effective way to take the temperature of collaboration and management.',
    ],
    features1en: [
      'Board Evaluation',
      'CEO Evaluation',
      'Meeting Evaluation',
      'Possibility to create your own surveys',
    ],
    texts1nb: [
      'For styrer som ønsker en enkel og effektiv måte å ta temperaturen på samarbeidet og ledelsen.',
    ],
    features1nb: [
      'Styreevaluering',
      'Evaluering av daglig leder',
      'Møteevaluering',
      'Mulighet for å opprette egne undersøkelser',
    ],
    icon: 'Surveys.svg',
    category: PACKAGE_CATEGORY.MODULE,
    dropThisOnOrderMainPackage: true, // This package is dropped when a main package is ordered
  },
  {
    reinvoicingRadioButton: ReinvoicingRadioButtonType.ASK,
    packageId: BillingPackageID.SUSPENDED,
    onlyClientAdminCanSeeIt: true,
    onlyClientAdminCanOrder: true,
    packageName: 'Suspended',
    orderIndex: 2,
    packagePrices: [],
    userPrices: [],
    signaturePrices: [],
    storagePrices: [],
    includedStorage: 0,
    includedUsers: -1,
    clientAdminOnly: true,
    isMainSubscription: true,
    hidePriceSection: true,
    hideAnnualSelector: true,
    texts1en: [],
    features1en: [],
    texts1nb: [],
    features1nb: [],
    icon: 'Orgbrain-pro.svg',
    category: PACKAGE_CATEGORY.ADMIN_LAYER,
    triggersDropOfAuxiliarySubscriptions: true, // If ordered this package, all auxiliary subscriptions are dropped
  },
  {
    excludeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.GRUNDER,
    isPackageHiddon: true,
    packageName: 'Grunder',
    orderIndex: 3,
    packagePrices: [
      {
        price: 2388,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: true,
      },
      {
        price: 249,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: false,
      },
    ],
    ...getUserPrices(),
    ...getRepeatableData(),
    packageMaxValidityDays: -1,
    isMainSubscription: true,
    includedStorage: 10737418240,
    includedUsers: 5,
    texts1en: [],
    features1en: [],
    texts1nb: [],
    features1nb: [],
    icon: 'Orgbrain-pro.svg',
    category: PACKAGE_CATEGORY.TIER2,
    triggersDropOfAuxiliarySubscriptions: true,
  },
  {
    excludeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.SMALL_BUSINESS,
    isPackageHiddon: true,
    packageName: 'Liten bedrift',
    orderIndex: 4,
    packagePrices: [
      {
        price: 5988,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: true,
      },
      {
        price: 629,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: false,
      },
    ],
    ...getUserPrices(),
    ...getRepeatableData(),
    packageMaxValidityDays: -1,
    isMainSubscription: true,
    includedStorage: 10737418240,
    includedUsers: 5,
    texts1en: [],
    features1en: [],
    texts1nb: [],
    features1nb: [],
    icon: 'Orgbrain-pro.svg',
    category: PACKAGE_CATEGORY.TIER2,
    triggersDropOfAuxiliarySubscriptions: true,
  },
  {
    excludeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.FOUNDER,
    isPackageHiddon: true,
    packageName: 'Gründerpakke',
    orderIndex: 5,
    packagePrices: [
      {
        price: 399 * 12,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: true,
      },
      {
        price: 798,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: false,
      },
    ],
    ...getUserPrices(398, 199),
    ...getRepeatableData(),
    packageMaxValidityDays: -1,
    isMainSubscription: true,
    includedStorage: 10737418240,
    includedUsers: 6,
    texts1en: [],
    features1en: [],
    texts1nb: [],
    features1nb: [],
    icon: 'Orgbrain-pro.svg',
    category: PACKAGE_CATEGORY.TIER2,
    triggersDropOfAuxiliarySubscriptions: true,
  },
  {
    excludeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.FOUNDER2024,
    featured: true,
    packageName: 'Gründerpakke',
    orderIndex: 5,
    packagePrices: [
      {
        price: 479 * 12,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: true,
      },
      {
        price: 918,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: false,
      },
    ],
    ...getUserPrices(458, 239),
    ...getRepeatableData(),
    packageMaxValidityDays: -1,
    isMainSubscription: true,
    includedStorage: 10737418240,
    includedUsers: 6,
    texts1en: ['The founder discount applies to businesses with annual income below NOK 3M.'],
    features1en: [
      'Includes 6 users',
      'Additional users: NOK 21.99 per month per user',
      'Full access to all Pro features',
    ],
    texts1nb: ['Gründerrabatten gjelder for virksomheter med årlig inntekt under NOK 3M.'],
    features1nb: [
      'Inkluderer 6 brukere',
      'Ekstra brukere: kr 219 pr måned pr bruker',
      'Full tilgang til alle Pro funksjoner',
    ],
    icon: 'Orgbrain-pro.svg',
    category: PACKAGE_CATEGORY.TIER2,
    triggersDropOfAuxiliarySubscriptions: true,
  },
  {
    excludeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.SMALL_BUSINESS2,
    isPackageHiddon: true,
    packageName: 'Liten bedrift-pakke',
    orderIndex: 6,
    packagePrices: [
      {
        price: 699 * 12,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: true,
      },
      {
        price: 1398,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: false,
      },
    ],
    ...getUserPrices(398, 199),
    ...getRepeatableData(),
    packageMaxValidityDays: -1,
    isMainSubscription: true,
    includedStorage: 10737418240,
    includedUsers: 6,
    texts1en: [],
    features1en: [],
    texts1nb: [],
    features1nb: [],
    icon: 'Orgbrain-pro.svg',
    category: PACKAGE_CATEGORY.TIER2,
    triggersDropOfAuxiliarySubscriptions: true,
  },
  {
    excludeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.SMALL_BUSINESS2024,
    featured: true,
    packageName: 'Liten bedrift-pakke',
    orderIndex: 6,
    packagePrices: [
      {
        price: 819 * 12,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: true,
      },
      {
        price: 1588,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: false,
      },
    ],
    ...getUserPrices(458, 239),
    ...getRepeatableData(),
    packageMaxValidityDays: -1,
    isMainSubscription: true,
    includedStorage: 10737418240,
    includedUsers: 6,
    texts1en: ['Small business discount applies to businesses with annual income below NOK 10M.'],
    features1en: [
      'Includes 6 users',
      'Additional users: NOK 21.99 per month per user',
      'Full access to all Pro features',
    ],
    texts1nb: ['Liten bedriftsrabatt gjelder for virksomheter med årlig inntekt under MNOK 10.'],
    features1nb: [
      'Inkluderer 6 brukere',
      'Ekstra brukere: kr 219 pr måned pr bruker',
      'Full tilgang til alle Pro funksjoner',
    ],
    icon: 'Orgbrain-pro.svg',
    category: PACKAGE_CATEGORY.TIER2,
    triggersDropOfAuxiliarySubscriptions: true,
  },
  {
    excludeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.BASIS,
    isPackageHiddon: true,
    packageName: 'Basis',
    orderIndex: 7,
    packagePrices: [],
    ...getUserPrices(398, 199),
    ...getRepeatableData(),
    packageMaxValidityDays: -1,
    isMainSubscription: true,
    includedStorage: 10737418240,
    includedUsers: -1,
    texts1en: [],
    features1en: [],
    texts1nb: [],
    features1nb: [],
    icon: 'Orgbrain-pro.svg',
    category: PACKAGE_CATEGORY.TIER2,
    triggersDropOfAuxiliarySubscriptions: true,
  },

  {
    excludeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.STANDARD2024,
    featured: true,
    packageName: 'Basis',
    orderIndex: 7,
    packagePrices: [],
    ...getUserPrices(458, 239),
    ...getRepeatableData(),
    packageMaxValidityDays: -1,
    isMainSubscription: true,
    includedStorage: 10737418240,
    includedUsers: -1,
    texts1en: [],
    features1en: [
      'For one board',
      'Free establishment',
      'Free for shareholders/members',
      'Free board school, value NOK 15,000',
      'Free Orgbrain eSign',
    ],
    texts1nb: [],
    features1nb: [
      'For ett styre',
      'Gratis etablering',
      'Gratis for aksjonærer/medl.',
      'Gratis styreskole, verdi kr 15.000,-',
      'Gratis Orgbrain eSign',
    ],
    icon: 'Orgbrain-pro.svg',
    category: PACKAGE_CATEGORY.TOP_TIER,
    triggersDropOfAuxiliarySubscriptions: true,
  },

  {
    excludeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.SHAREHOLDER_BASIS,
    onlyClientAdminCanSeeIt: true,
    packageName: 'Shareholder Basis',
    orderIndex: 7,
    packagePrices: [],
    userPrices: [],
    onlyClientAdminCanOrder: true,
    ...getRepeatableData(),
    packageMaxValidityDays: -1,
    isMainSubscription: false, //TASK_ABOUT_PAYMENT
    includedStorage: 10737418240,
    includedUsers: -1,
    texts1en: [],
    features1en: [
      'Shareholder Register',
      'Transactions',
      'Beneficial Owners',
      'Shareholder Register Statement',
      'Altinn Integration',
      'Communication',
      'Data Room',
      'Free Orgbrain eSign',
    ],
    texts1nb: [],
    features1nb: [
      'Aksjeeierbok',
      'Transaksjoner',
      'Reelle rettighetshavere',
      'Aksjonærregisteroppgaven',
      'Altinn-integrasjon',
      'Kommunikasjon',
      'Datarom',
      'Gratis Orgbrain eSign',
    ],
    icon: 'Shareholder-icon.svg',
    category: PACKAGE_CATEGORY.ADMIN_LAYER,
    triggersDropOfAuxiliarySubscriptions: true,
    dropThisOnOrderMainPackage: true, // This package is dropped when a main package is ordered
  },

  {
    excludeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.SHAREHOLDER_PRO,
    packageName: 'Shareholder Pro',
    orderIndex: 7,
    packagePrices: [
      {
        price: 5990,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: true,
      },
    ],
    userPrices: [],
    ...getRepeatableData(),
    packageMaxValidityDays: -1,
    isMainSubscription: false, //TASK_ABOUT_PAYMENT
    includedStorage: 10737418240,
    includedUsers: -1,
    hideAnnualSelector: true,
    texts1en: [],
    features1en: [
      'General Meetings',
      'Shareholder Register',
      'Transactions',
      'Capital Increases',
      'Beneficial Owners',
      'Shareholder Register Statement',
      'Altinn Integration',
      'Communication',
      'Data Room',
      'Free Orgbrain eSign',
    ],
    texts1nb: [],
    features1nb: [
      'Generalforsamlinger',
      'Aksjeeierbok',
      'Transaksjoner',
      'Kapitalforhøyelser',
      'Reelle rettighetshavere',
      'Aksjonærregisteroppgaven',
      'Altinn-integrasjon',
      'Kommunikasjon',
      'Datarom',
      'Gratis Orgbrain eSign',
    ],
    icon: 'Shareholder-icon.svg',
    category: PACKAGE_CATEGORY.MODULE,
    dropThisOnOrderMainPackage: true,
  },

  {
    excludeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.ENTERPRISE,
    packageName: 'Enterprise',
    onlyClientAdminCanOrder: true,
    orderIndex: 8,
    packagePrices: [
      {
        price: 19900,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: true,
      },
      {
        price: 1990,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: false,
      },
    ],
    userPrices: [],
    ...getRepeatableData(),
    packageMaxValidityDays: -1,
    isMainSubscription: true,
    includedStorage: 10737418240,
    includedUsers: -1,
    texts1en: ['⠀', 'Orgbrain Pro and in addition:'],
    features1en: [
      'Multiple Boards',
      'Group Customizations',
      'Extended Support',
      'Shared Data Room',
    ],
    texts1nb: ['⠀', 'Orgbrain Pro og i tillegg:'],
    features1nb: ['Flere styrer', 'Konserntilpasninger', 'Utvidet support', 'Delt datarom'],
    icon: 'Orgbrain-Enterprise.svg',
    category: PACKAGE_CATEGORY.TOP_TIER,
    triggersDropOfAuxiliarySubscriptions: true,
  },

  {
    includeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.NIF_PRO,
    featured: true,
    packageName: 'Nif pro',
    orderIndex: 6,
    packagePrices: [
      {
        price: 819 * 12,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: true,
      },
      {
        price: 1588,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: false,
      },
    ],
    userPrices: [],
    ...getRepeatableData(),
    isMainSubscription: true,
    includedStorage: 10737418240,
    includedUsers: 0,
    // discounts: [
    //   {
    //     discountType: 'DISCOUNT_USER_COUNT_ROLE_BASED',
    //     discountAmount: -1,
    //     discountDurationMonths: -1,
    //     discountAddedTimestamp: new Date(),
    //     discountRole: 'BOARDMEMBER',
    //   },
    // ],
    texts1en: ['NIF Basis and in addition:'],
    features1en: [
      'Annual meetings',
      'Membership register',
      'Subgroups',
      'Free for members',
      'Free board school, value NOK 15,000,-',
    ],
    texts1nb: ['NIF Basis og i tillegg:'],
    features1nb: [
      'Årsmøter',
      'Medlemsregister',
      'Undergrupper',
      'Gratis for medlemmer',
      'Gratis styreskole, verdi kr 15 000,-',
    ],
    icon: 'NIF-pro.svg',
    category: PACKAGE_CATEGORY.NIF,
    triggersDropOfAuxiliarySubscriptions: true,
  },

  {
    includeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.NIF_START,
    packageName: 'Nif start',
    orderIndex: 6,
    packagePrices: [
      {
        price: 479 * 12,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: true,
      },
      {
        price: 918,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: false,
      },
    ],
    userPrices: [],
    ...getRepeatableData(),
    isMainSubscription: true,
    includedStorage: 10737418240,
    includedUsers: 0,
    // discounts: [
    //   {
    //     discountType: 'DISCOUNT_USER_COUNT_ROLE_BASED',
    //     discountAmount: -1,
    //     discountDurationMonths: -1,
    //     discountAddedTimestamp: new Date(),
    //     discountRole: 'BOARDMEMBER',
    //   },
    // ],
    texts1en: [],
    features1en: [
      'Board meetings',
      'Data room',
      'Communication',
      'Tasks',
      'Free Orgbrain eSign',
      'Free setup',
    ],
    texts1nb: [],
    features1nb: [
      'Styremøter',
      'Datarom',
      'Kommunikasjon',
      'Oppgaver',
      'Gratis Orgbrain eSign',
      'Gratis etablering',
    ],
    icon: 'NIF-pro.svg',
    category: PACKAGE_CATEGORY.NIF,
    triggersDropOfAuxiliarySubscriptions: true,
  },

  {
    excludeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.DD_SUBSCRIPTION,
    packageName: 'DD_SUBSCRIPTION',
    orderIndex: 101,
    packagePrices: [],
    ddProcessPrices: [
      {
        price: 82.5 * 12,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: true,
      },
      {
        price: 990,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: false,
      },
    ],
    isMainSubscription: false,
    onlyClientAdminCanSeeIt: false,
    includedStorage: 10737418240,
    includedUsers: 0,
    hideAnnualSelector: true,
    texts1en: ['You can create an unlimited number of data rooms and users for each process.'],
    features1en: [],
    texts1nb: ['Du kan opprette ubegrenset antall datarom og brukere for hver prosess.'],
    features1nb: [],
    icon: 'Due-dilligence.svg',
    category: PACKAGE_CATEGORY.SERVICES,
  },
  {
    excludeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.SIGNATURE_PACKAGE,
    packageName: 'SIGNATURE_PACKAGE',
    orderIndex: 102,
    packagePrices: [
      {
        price: 708,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: true,
      },
    ],
    isMainSubscription: false,
    onlyClientAdminCanSeeIt: true,
    includedBankIdSignatures: 100,
    includedUsers: 0,
    hideAnnualSelector: true,
    autoRenewAfterQuotaIsOver: true,
    quotaRenewalTriggers: ['includedBankIdSignatures'],
    texts1en: [],
    features1en: [],
    texts1nb: [],
    features1nb: [],
    icon: 'Bank-ID.svg',
    category: PACKAGE_CATEGORY.SERVICES,
  },
  {
    excludeOrgTypes: [CompanyAcronymsEnum.NIF],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.SECURITY_PRO,
    packageName: 'SECURITY_PRO',
    orderIndex: 103,
    packagePrices: [
      {
        price: 1068,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: true,
      },
    ],
    isMainSubscription: false,
    onlyClientAdminCanSeeIt: true,
    includedStorage: 0,
    includedUsers: 0,
    hideAnnualSelector: true,
    texts1en: [],
    features1en: [],
    texts1nb: [],
    features1nb: [],
    icon: 'Group5808.svg',
    category: PACKAGE_CATEGORY.SERVICES,
  },
  {
    excludeOrgTypes: [],
    reinvoicingRadioButton: ReinvoicingRadioButtonType.YES,
    packageId: BillingPackageID.AI_TRANSCRIPTION_PACKAGE,
    packageName: 'AI_TRANSCRIPTION_PACKAGE',
    orderIndex: 102,
    packagePrices: [
      {
        price: 1000,
        currency: SUPPORTED_CURRENCY.NOK,
        isAnnualPrice: true,
      },
    ],
    customPricesTexts: 'TranscriptionCustomPricesTexts',
    isMainSubscription: false,
    onlyClientAdminCanSeeIt: true,
    includedBankIdSignatures: 0,
    includedUsers: 0,
    hideAnnualSelector: true,
    autoRenewAfterQuotaIsOver: true,
    quotaRenewalTriggers: ['includedBankIdSignatures'],
    texts1en: [],
    features1en: [],
    texts1nb: [],
    features1nb: [],
    icon: 'AI-transkrib.svg',
    category: PACKAGE_CATEGORY.SERVICES,
  },
] as OrganizationSubscriptionDeclaration[];

packageDump.sort((a, b) => a.orderIndex - b.orderIndex);

const packageMap = {};
for (const pack of packageDump) {
  packageMap[pack.packageId] = pack;
}
export { packageMap };
